import React from 'react';
import styles from './VStack.module.scss';

interface Props {
	children?: React.ReactElement | React.ReactElement[];
	spacing?: number;
}

const VStack: React.FC<Props> = ({ children, spacing }) => {
	const style: React.CSSProperties = {};

	if (spacing) {
		style.gap = `${spacing}px`;
	}

	return (
		<div className={styles.wrapper} style={style}>
			{children}
		</div>
	);
};

export default VStack;
